import { endOfDay, isAfter, parseISO } from 'date-fns';

/**
 * Returns whether the quote-expired modal should be shown when the user clicks Confirm cancellation.
 * The quote is valid until 23:59 on the given date; if current time is past that, they must restart the journey.
 *
 * @param quoteDateISO - ISO date string for the quote (the date it applies to), or undefined
 * @returns true if quoteDateISO is set and current time is past 23:59 on that date
 */
export function shouldShowQuoteExpiredModal(quoteDate: string | undefined): boolean {
	if (!quoteDate?.trim()) {
		return false;
	}

	const quoteDateISO = parseISO(quoteDate);
	const endOfQuoteDay = endOfDay(quoteDateISO);

	return isAfter(new Date(), endOfQuoteDay);
}
